import React from 'react';

function QuoteClose({ color = 'text-shuttle-grey', size = 'w-8 h-8' }) {
	return (
		<svg className={`fill-current ${color} ${size}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 24">
			<path
				d="M682.4,173.053892 C681.71679,175.960094 680.591063,179.60876 679.022785,184 C677.454507,188.39124 675.847434,192.3912 674.201519,196 L664,196 C666.049631,187.473011 667.617885,179.473091 668.70481,172 L681.747848,172 L682.4,173.053892 Z M704,173.053892 C703.31679,175.960094 702.191063,179.60876 700.622785,184 C699.054507,188.39124 697.447434,192.3912 695.801519,196 L685.6,196 C687.649631,187.473011 689.217885,179.473091 690.30481,172 L703.347848,172 L704,173.053892 Z"
				transform="translate(-664 -172)"
				id="quoteClose"
			/>
		</svg>
	);
}

export default QuoteClose;
